/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_View_KanbanInputs */

const en_dashboard_view_kanban = /** @type {(inputs: Dashboard_View_KanbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban`)
};

const pt_br2_dashboard_view_kanban = /** @type {(inputs: Dashboard_View_KanbanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanban`)
};

/**
* | output |
* | --- |
* | "Kanban" |
*
* @param {Dashboard_View_KanbanInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_view_kanban = /** @type {((inputs?: Dashboard_View_KanbanInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_View_KanbanInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_view_kanban(inputs)
	return pt_br2_dashboard_view_kanban(inputs)
});